var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"my-10",attrs:{"show":"","variant":"danger"}},[_c('ul',{staticClass:"px-5"},[_vm._l((_vm.validationErrors),function(error,i){return [_c('li',{key:i,staticClass:"py-1"},[_vm._v(" "+_vm._s(error.errors[0])+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }